export default [
  {
    id: 1,
    title: 'Device Info'
  },
  {
    id: 2,
    title: 'PoC'
  },
  {
    id: 3,
    title: 'Billing'
  },
  {
    id: 4,
    title: 'Lab Info'
  },
  {
    id: 5,
    title: 'Documents'
  },
  {
    id: 6,
    title: 'Agreements'
  }
];



// WEBPACK FOOTER //
// ./src/components/Stepper/initialSteps.js